/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _4 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>4 - Типы внутренних данных компонента</h2>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        <code className={styles.code}>static data</code> - статические свойства и методы к которым необходимо получать
        доступ без экземпляра.
      </li>
      <li className={styles.list__item}>
        <code className={styles.code}>this.state.data</code> - динамические данные изменяющиеся методами компонента,
        состояние.
      </li>
      <li className={styles.list__item}>
        <code className={styles.code}>this.data</code> - данные которые будут разные для каждого экземпляра.
      </li>
      <li className={styles.list__item}>
        <code className={styles.code}>const DATA</code> - константы, данные которые не изменяются и одинаковы для всех
        экземпляров.
      </li>
    </ul>
  </section>
))
